<template>
    <div v-if="value.meta">
      <el-divider />
        <h3>Additional Details</h3>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-input-title>Bow Type</el-input-title>
        <el-select class="mt-05" v-model="value.meta.bowType" placeholder="Bow Type" multiple>
          <el-option v-for="e in bowTypes" :label="e" :key="e" :value="e" />
        </el-select>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-input-title required>Home Club</el-input-title>
        <el-form-item prop="meta.homeClub">
          <el-select
            filterable
            remote
            reserve-keyword
            value-key="_id"
            class="mt-05 w-100"
            v-model="value.meta.homeClub"
            :remote-method="searchClub"
            placeholder="Select">
            <el-option
              v-for="{ _id, value } in clubs"
              :key="_id"
              :label="value"
              :value="{_id, value}">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.clubCode">
          <el-input-title>Club Code</el-input-title>
          <el-input class="mt-05" v-model="value.meta.clubCode" placeholder="Club Code" />
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.otherClubs">
          <el-input-title required>Other Clubs</el-input-title>
          <el-select
            class="mt-05"
            multiple
            value-key="_id"
            v-model="value.meta.otherClubs"
            :remote-method="searchClub"
            remote
            placeholder="Enter club name to start searching"
            filterable
          >
            <el-option
              v-for="{ _id, value } in clubs"
              :label="value"
              :key="_id"
              :value="{_id, value}"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.interestOne">
          <el-input-title>Interest</el-input-title>
          <el-select class="mt-05" v-model="value.meta.interestsOne" multiple placeholder="Interest (Target, Field, Indoor, Clout)?">
            <el-option v-for="e in interests" :label="e" :key="e" :value="e" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.isAboriginal" label="Are you of Aboriginal and/or Torres Strait Islander origin?">
          <el-select v-model="value.meta.isAboriginal" placeholder="Yes / No">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.name" :value="e.name" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    </div>
  </template>
<script>
import playerDetails from '@/mixins/player-details';
import { get } from 'lodash';

export default {
  name: 'ArcheryExtra',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      clubs: [],
      inputValue: '',
      inputVisible: false,
      selectedName: '',
      selectedClubs: [],
      yesNoOptions: [
        {
          name: 'Yes',
          type: true,
        },
        {
          name: 'No',
          type: false,
        },
        {
          name: '',
          type: ''
        },
      ],
      bowTypes: [
        'Barebow Compound',
        'Barebow Recurve',
        'Bowhunter:Limited',
        'Bowhunter:Unlimited',
        'Compound',
        'Longbow',
        'Recurve',
        'Sporting Crossbow',
        'Target Crossbow',
      ],
      interests: [
        'Target',
        'Field',
        'Indoor',
        'Clout',
      ],
    };
  },
  mounted() {
    if (this.value.meta && this.value.meta.homeClub) this.selectedName = this.value.meta.homeClub.name;
    if (this.value.meta && this.value.meta.clubs) this.selectedClubs = this.value.meta.clubs.map((club) => ({ _id: club._id, value: club.name }));
    this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: '' }).then((res) => {
      const data = res.data.data.map((c) => ({ value: c.name, _id: c._id, meta: { code: get(c, 'meta.code') } }));
      // Append none
      data.unshift({ value: 'None', _id: 'none' });
      this.clubs = data;
    }).catch(() => {});
  },
  methods: {
    handleSelect() {
      this.value.meta.clubs = this.selectedClubs.map((club) => ({ _id: club._id, name: club.value }));
    },
    handleClose(email) {
      this.value.meta.coachesEmails.splice(this.value.meta.coachesEmails.indexOf(email), 1);
    },
    showInput() {
      if (this.value.meta.coachesEmails.length >= 5) return this.$message.error('You can only have a maximum of 5 coaches emails');
      this.inputVisible = true;
      // eslint-disable-next-line no-unused-vars
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
      return false;
    },
    searchClub(query) {
      this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: query }).then((res) => {
        const data = res.data.data.map((c) => ({ value: c.name, _id: c._id, meta: { code: get(c, 'meta.code') } }));
        // Append none
        data.unshift({ value: 'None', _id: 'none' });
        this.clubs = data;
      }).catch(() => {});
    },
    handleInputConfirm() {
      const { inputValue } = this;
      if (inputValue) {
        const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        if (re.test(String(inputValue).toLowerCase())) this.value.meta.coachesEmails.push(inputValue);
        else return this.$message.error('Invalid Email');
      }
      this.inputVisible = false;
      this.inputValue = '';
      return false;
    }
  },
  computed: {

  },
  watch: {
    'value.meta.homeClub': {
      handler(val) {
        const { _id } = val;
        const found = this.clubs.find((c) => c._id === _id);
        console.log({ found });
        if (found && found.meta && found.meta.code) this.value.meta.clubCode = found.meta.code;
        this.$forceUpdate();
      },
      deep: true,
    }
  }
};
</script>

  <style lang="scss" scoped>

  .el-autocomplete,
  .el-select,
  .el-input {
    width: 100%;
  }

  </style>
